<template>
  <div>
    <p>{{ $t('empty_list.no_data_available') }}</p>
    <p>{{ $t('empty_list.filter_case') }} <span class="ls-cursor-pointer clear-filter-link" @click="$parent.$emit('clearFilters')">{{ $t('empty_list.clear_filter') }}</span> {{ $t('empty_list.back_to_default_list') }}</p>
  </div>
</template>
<script>
  export default {
    name: 'empty-list'
  }
</script>
<style>
  .clear-filter-link {
    color: #D75553;
    text-decoration: underline;
  }
</style>



// WEBPACK FOOTER //
// EmptyList.vue?7757eb76